<template>
  <div id="LoginRegisterFullPage">

    <div class="modal-wrapper">
      <Logo class = "with-padding-margin" />

      <div id="resetpwd-card" class = "modal-card with-border">
        <header class="modal-card-head">
          <p class="modal-card-title">¿Has olvidado tu contraseña?</p>
        </header>

        <section class="modal-card-body login-container">
          <div v-if="$store.state.signup.activationLoading">
            loading...
          </div>
          <div v-else>
            <div v-if="!$store.state.signup.activationError" class="has-text-centered">
              <h1> ¡Cuenta verificada! </h1>
              <p>Puedes ir a <router-link :to="{ name: 'User'}">tu página de perfil</router-link></p>
            </div>
            <div v-else>
              <p>Ha ocurrido un error verificando la dirección de email con esta clave.</p>
            </div>
          </div>
        </section>
        <footer class="modal-card-foot">
          <router-link class="btn" :to="{ name: 'Home'}">Volver</router-link>
        </footer>
      </div>
    </div>
  </div>
</template>
<script>

import LoginUser from './LoginUser'
import RegisterUser from './RegisterUser'
import Logo from '../UI/Logo'

export default {
  name: 'LoginRegisterFullPage',
  props: {
    'emailkey': {
      type: String,
      required: true
    }
  },
  components: {
    Logo,
    LoginUser,
    RegisterUser
  },
  data: () => ({

  }),
  methods: {
    goTo (page) {
      this.$router.push(page)
    }
  },
  created () {
    // do something after creating vue instance
    console.log(this.emailkey)
    this.$store.dispatch('signup/activateAccount', {'key': this.emailkey})
  }
}
</script>
<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// src/components/Login/VerifyEmail.vue